<template>
  <v-container fluid>
    <div style="text-align: center;" class="display-1 font-weight-thin">Solicitação de Pagamento para Adiantamento</div>

    <v-snackbar auto-height v-model="snackbar.ativo" :timeout="snackbar.timeout" top right :color="snackbar.color">{{
      snackbar.text }}</v-snackbar>

    <v-layout row wrap>
      <v-flex xs12 style="height: 100%" v-if="solicitacaoDeAdiantamento.motivoDaReprovacao != ''">
        <v-container class="pb-0 pt-3">
          <v-toolbar class="red lighten-1">
            <v-toolbar-title class="white--text">Motivo reprovação</v-toolbar-title>
          </v-toolbar>

          <v-content class="red lighten-2">
            <v-form>
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-textarea label="Reprovação" prepend-icon="note"
                    v-model="solicitacaoDeAdiantamento.motivoDaReprovacao" readonly></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>
        </v-container>
      </v-flex>

      <v-flex xs12 style="height: 100%">
        <v-container class="pt-3">
          <integracao-mensagem :mensagemIntegracao="solicitacaoDeAdiantamento.mensagemIntegracao"
            :statusIntegracao="solicitacaoDeAdiantamento.statusIntegracao"
            @chamaFuncao="prepararRequest('APROVAR')"></integracao-mensagem>

          <v-toolbar class="blue-grey lighten-4 elevation-2">
            <v-toolbar-title>Dados Gerais</v-toolbar-title>
          </v-toolbar>

          <v-content class="grey lighten-4">
            <v-form v-model="validacaoAdiantamento" ref="formAdiantamento">
              <v-layout row wrap>
                <v-flex md3 xs12>
                  <v-autocomplete label="Selecione a Empresa" append-icon="business_center"
                    v-model="solicitacaoDeAdiantamento.idDaEmpresa" :loading="loadingCompanies" :items="empresas.content"
                    item-value="id" item-text="nome" :rules="regraEmpresa" :readonly="!podeEditar"
                    :disabled="solicitacaoDeAdiantamento.rateios.length >= 1">
                    <template slot="selection" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="item" slot-scope="data">{{ data.item.id }} - {{ data.item.nome }}</template>
                    <template slot="no-data">
                      <div class="noDataSlot">Nenhuma empresa cadastrada</div>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md2 xs12>
                  <v-text-field label="Número do Pedido" v-model="solicitacaoDeAdiantamento.numeroDoPedido"
                    :rules="regraNumeroDoPedido" :readonly="!podeEditar && !verificaPerfilFinanceiro"></v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <v-autocomplete label="Moeda" v-model="solicitacaoDeAdiantamento.tipoDeMoeda"
                    prepend-icon="monetization_on" :rules="regraTipoDeMoeda" :items="tiposDeMoeda" item-text="nome"
                    item-value="valor" :readonly="!podeEditar" @change="alteraCampoValor($event)"></v-autocomplete>
                </v-flex>
                <v-flex md2 xs12>
                  <v-text-field append-icon="local_atm" label="Valor" v-model="solicitacaoDeAdiantamento.total"
                    @blur="formataValorDeAdiantamento" :rules="regraValorDoAdiantamento"
                    :readonly="!podeEditar"></v-text-field>
                </v-flex>

                <v-flex md2 xs12>
                  <c-seletor-data nomeDoCampo="Data de Vencimento" :data="solicitacaoDeAdiantamento.vencimento"
                    :regras="regraDataVencimento" :ehEditavel="!podeEditar && !verificaPerfilFinanceiro"
                    @pegarData="(dataInserida) => solicitacaoDeAdiantamento.vencimento = dataInserida"
                    @validacaoFormulario="(formularioValidado) => validacaoSeletorData = formularioValidado">
                  </c-seletor-data>
                </v-flex>

                <v-flex md12 xs12>
                  <v-textarea label="Finalidade" prepend-icon="note" v-model="solicitacaoDeAdiantamento.finalidade"
                    :readonly="!podeEditar" :rules="finalidadeRules" class="mb-2"></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
          </v-content>

          <v-divider class="mx-6 my-2" inset dark></v-divider>
          <component-rateio-despesas :rateiosCadastrados="solicitacaoDeAdiantamento.rateios" :podeEditar="podeEditar"
            :ehAprovador="ehAprovador" :tipoDeMoeda="solicitacaoDeAdiantamento.tipoDeMoeda"
            :valorTotal="solicitacaoDeAdiantamento.total" :idDaEmpresa="solicitacaoDeAdiantamento.idDaEmpresa"
            @rateios="solicitacaoDeAdiantamento.rateios = $event"></component-rateio-despesas>

          <v-divider class="mx-6 my-2" inset dark></v-divider>

          <c-box-fornecedor @receberBusca="solicitacaoDeAdiantamento.cnpj_cpf = $event"
            @receberFornecedor="receberFornecedor($event)" :fornecedorRecebido="fornecedorRecebido"
            :podeEditar="podeEditar"></c-box-fornecedor>

          <v-divider class="mx-6 my-2" inset dark></v-divider>
          <v-content v-if="solicitacaoDeAdiantamento.observacao != '' || ehAprovador">
            <v-toolbar class="yellow lighten-3">
              <v-toolbar-title>Observações</v-toolbar-title>
            </v-toolbar>

            <v-content class="yellow lighten-4">
              <v-form>
                <v-layout row wrap>
                  <v-flex md12 xs12>
                    <v-textarea v-model="solicitacaoDeAdiantamento.observacao" name="name" prepend-icon="note"
                      :readonly="!ehAprovador || !podeVisualizar()"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-content>
          </v-content>

          <!-- operações do solicitante -->
          <v-card-actions v-if="podeEditar">
            <v-spacer></v-spacer>
            <v-btn style="font-weight: bold;" color="indigo darken-4" flat :loading="loadingRequest"
              @click.native="validarExcecao()" :disabled="!passouNasRegrasDeValidacao || !validacaoSeletorData">Enviar
              para aprovação</v-btn>
          </v-card-actions>

          <v-dialog @keydown.esc="dialogoAprovador = false" onsubmit="return false;" v-model="dialogoAprovador"
            max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Selecione um aprovador</span>
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-autocomplete label="Selecione um aprovador" v-model="aprovadorSelecionado"
                    :loading="loadingAprovador" :items="aprovadores" item-text="nome" item-value="id">
                    <template slot="no-data">
                      <div class="noDataSlot">Nenhum aprovador encontrado.</div>
                    </template>
                  </v-autocomplete>
                </v-form>
              </v-card-text>

              <v-card-actions style="background-color: #fff">
                <v-spacer></v-spacer>
                <v-btn color="pink" flat v-if="!loadingRequest" @click.native="fechar">Cancelar</v-btn>

                <v-progress-circular indeterminate color="blue" v-if="loadingRequest"></v-progress-circular>

                <v-btn color="indigo darken-4" flat v-if="!loadingRequest"
                  @click.native="prepararRequest('ENVIAR_PARA_APROVACAO')"
                  :disabled="!aprovadorSelecionado">Enviar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- operações para aprovadores -->
          <v-card-actions v-if="ehAprovador && podeVisualizar()">
            <v-spacer></v-spacer>
            <v-progress-circular class="mr-2" indeterminate color="primary" v-if="loadingRequest"></v-progress-circular>

            <v-btn color="error" :disabled="loadingRequest"
              @click.native="dialogConfirmarReprovacao = true">Reprovar</v-btn>

            <v-btn v-if="solicitacaoDeAdiantamento.status != 'APROVADO_PELO_PROCURADOR'" color="success"
              @click.native="conferirExcecao()" :disabled="loadingRequest">Aprovar</v-btn>
          </v-card-actions>

          <v-dialog @keydown.esc="dialogConfirmarReprovacao" v-model="dialogConfirmarReprovacao" max-width="500px">
            <v-card style="background-color: #eceff1">
              <v-card-title class="error">
                <span class="mx-auto text-center" style="font-size: 1.4em;color: white">Digite o motivo da
                  reprovação</span>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-textarea background-color="#cfd8dc" color="error"
                    v-model="solicitacaoDeAdiantamento.motivoDaReprovacao"></v-textarea>
                </v-form>

                <v-layout row wrap>
                  <v-btn color="error" class="ml-0" @click="dialogConfirmarReprovacao = false">Cancelar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="mr-0" @click="prepararRequest('REPROVAR')">Reprovar</v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogConfirmarAprovacao" max-width="500px">
            <v-card style="background-color: #005ca3;">
              <v-card-title primary-title class="pb-0">
                <p class="title font-weight-medium text-center mx-auto"
                  style="color: white; text-align: center !important;">{{ msgExcecao }}</p>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-layout row wrap v-if="this.solicitacaoDeAdiantamento.status != 'REPROVADO_PELO_PROCURADOR'"
                  class="pb-2">
                  <v-btn color="white" class="ml-5" @click="dialogConfirmarAprovacao = false">Não</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="mr-5" @click="prepararRequest('APROVAR')">Sim</v-btn>
                </v-layout>
                <v-layout row wrap class="pb-2" v-else>
                  <v-btn color="white" class="ml-5"
                    @click="prepararRequest('ENVIADO_PARA_CONTABILIDADE')">Contabilidade</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="white" class="mr-5" @click="prepararRequest('ENVIADO_PARA_PROCURADOR')">Procurador</v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogExcecao" max-width="500px">
            <v-card color="info">
              <v-card-title>
                <span class="text-xs-center" style="font-size: 1.2em; color: white;">{{ msgExcecao }}</span>
              </v-card-title>
              <v-card-text class="pt-1">
                <div class="text-xs-center">
                  <v-btn style="font-weight: bold;" color="white" @click.native="() => {
                    dialogExcecao = false;
                  }">Não</v-btn>
                  <v-btn style="font-weight: bold;" color="white" @click.native="() => {
                    dialogExcecao = false;
                    buscarAprovadores()
                  }">Sim</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <logs-pedidos class="mt-3" v-if="solicitacaoDeAdiantamento.logs != null"
            :logs="solicitacaoDeAdiantamento.logs"></logs-pedidos>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import RateioDespesas from "@/components/solicitacao/RateioDeDespesas.vue";
import LogsPedidos from "@/components/solicitacao/LogsPedidos.vue";
import IntegracaoMensagem from "@/components/shared/IntegracaoMensagem.vue";
import axios from "axios";
import BoxFornecedor from "@/components/solicitacao/BoxFornecedor.vue";
import conversor from "../../../mixins/moedasMixin.js";
import { feriados, converterLogParaHorarioDeSaoPaulo } from "../../../mixins/dateMixin.js";
import moment from "moment";
import business from "moment-business";
import cloneDeep from "lodash.clonedeep";
import SeletorData from "../../shared/SeletorData";
import { substituirCaracteres } from '../../../mixins/validarCampos.js';
import { validarSeUsuarioLogadoPodeVerPedido } from "@/mixins/visualizacaoPedidos.js";

export default {
  data() {
    return {
      msgExcecao: "",
      dialogExcecao: false,
      validacaoAdiantamento: false,
      usuarioLogado: null,
      podeEditar: true,
      ehAprovador: false,
      solicitacaoDeAdiantamento: {
        excecao: false,
        vencimento: null,
        idDoSolicitante: null,
        idDoAprovador: null,
        idDaEmpresa: null,
        numeroDoPedido: null,
        tipoDeMoeda: "BRL",
        total: null,
        finalidade: "",
        rateios: [],
        favorecido: "",
        cnpj_cpf: null,
        observacao: "",
        pagamento: {
          conta: {
            id: null
          }
        },
        motivoDaReprovacao: "",
        status: "",
        idDoFornecedor: null
      },
      tiposDeMoeda: [
        {
          valor: "BRL",
          nome: "R$ - Real Brasileiro"
        },
        {
          valor: "USD",
          nome: "US$ - Dólar dos EUA"
        },
        {
          valor: "AUD",
          nome: "A$ - Dólar Australiano"
        },
        {
          valor: "CAD",
          nome: "C$ - Dólar do Canadá"
        },
        {
          valor: "JPY",
          nome: "¥ - Iene"
        },
        {
          valor: "EUR",
          nome: "€ - Euro"
        },
        {
          valor: "GBP",
          nome: "£ - Libra"
        },
        {
          valor: "SGD",
          nome: "S$ - Dólar da Singapura"
        },
        {
          valor: "MXN",
          nome: "Mex$ - Peso Mexicano"
        }
      ],
      finalidadeRules: [
        // Desculpe por isso meu eu do futuro :(
        finalidade => {
          if (finalidade.length <= 10) {
            return "Finalidade deve ter no mínimo 10 caracteres."
          }
          if (finalidade.length > 255) {
            return `Finalidade excedeu o limite de caracteres. 
            O número máximo permitido é de 255 caracteres`
          }
        }
      ],
      loadingRequest: false,
      dialogoAprovador: false,
      loadingAprovador: false,
      loadingBusca: false,
      aprovadores: [],
      aprovadorSelecionado: "",
      dialogConfirmarAprovacao: false,
      dialogConfirmarReprovacao: false,
      regraEmpresa: [
        empresa => !!empresa || "A seleção de uma empresa é obrigatória."
      ],
      regraTipoDeMoeda: [
        moeda => !!moeda || "A seleção do tipo de moeda é obrigatória."
      ],
      regraNumeroDoPedido: [
        numero => !!numero || "Número de pedido é obrigatório.",
        numero => isNaN(numero) ? "Este campo só pode conter números" : true
      ],
      regraNomeFornecedor: [numero => !!numero || "Este campo é obrigatório."],
      regraValorDoAdiantamento: [
        valor => !!valor || "Valor do adiantamento é obrigatório."
      ],
      fornecedorRecebido: {},
      snackbar: {
        ativo: false,
        timeout: 6000,
        color: "success",
        text: "Salvo com successo!"
      },
      regraDataVencimento: [data => {
        if (data == "Invalid date") return "Data de vencimento é obrigatória"
        else return data.length >= 8 || "Digite uma data válida."
      }],
      validacaoSeletorData: false
    };
  },
  components: {
    componentRateioDespesas: RateioDespesas,
    LogsPedidos,
    IntegracaoMensagem,
    "c-box-fornecedor": BoxFornecedor,
    "c-seletor-data": SeletorData
  },
  computed: {
    retornaTextoCorretoParaFinanceiro() {
      if (this.solicitacaoDeAdiantamento.status == "REPROVADO_PELO_PROCURADOR")
        return "Para quem deseja enviar?";
      else return "Confirmar aprovação do pedido?";
    },
    verificaPerfilFinanceiro() {
      if (
        this.usuarioAutenticado.papeis.filter(
          papel => papel.nome === "APROVADOR_FINANCEIRO"
        ).length != 0 &&
        (this.solicitacaoDeAdiantamento.status == "ENVIADO_PARA_FINANCEIRO" ||
          this.solicitacaoDeAdiantamento.status == "REPROVADO_PELO_PROCURADOR")
      ) {
        return true;
      } else return false;
    },
    empresas() {
      return this.$store.getters.empresas;
    },
    usuarioAutenticado() {
      return this.$store.getters.usuarioAutenticado;
    },
    loadingCompanies() {
      return this.$store.getters.loadingCompanies;
    },
    passouNasRegrasDeValidacao() {
      let valorPraComparar = this.calculaRateios();
      const converteValorParaComparar = conversor.methods.converterValorStringEmNumero(
        valorPraComparar,
        this.solicitacaoDeAdiantamento.tipoDeMoeda
      );

      valorPraComparar = conversor.methods.converterParaMoedaReal(
        converteValorParaComparar,
        this.solicitacaoDeAdiantamento.tipoDeMoeda
      );

      if (
        this.validacaoAdiantamento &&
        valorPraComparar == this.solicitacaoDeAdiantamento.total &&
        this.solicitacaoDeAdiantamento.favorecido.length > 0
      )
        return true;
      else return false;
    }
  },
  methods: {
    conferirExcecao() {
      if (this.solicitacaoDeAdiantamento.status == "ENVIADO_PARA_GESTOR") {
        this.solicitacaoDeAdiantamento.excecao = this.retornaExcecao(
          "dialogConfirmarAprovacao"
        );
      } else {
        this.dialogConfirmarAprovacao = true;
        this.msgExcecao = this.retornaTextoCorretoParaFinanceiro;
      }
    },
    retornaExcecao(dialogParaAbrir) {
      const range = this.calculaRangeDeData(
        this.solicitacaoDeAdiantamento.vencimento
      );
      if (range < 5) {
        this[dialogParaAbrir] = true;
        if (range < 0)
          this.msgExcecao = "Atenção! Documento vencido, deseja continuar? \n (Antes de enviar ao financeiro contate seu fornecedor para negociar uma nova data de pagamento!)";
        else
          this.msgExcecao =
            "Atenção! Pagamento fora do prazo de cinco dias úteis antes do vencimento, deseja continuar? \n (Antes de enviar ao financeiro contate seu fornecedor para negociar uma nova data de pagamento!)";
        return true;
      } else {
        this[dialogParaAbrir] = true;
        this.msgExcecao = this.retornaTextoCorretoParaFinanceiro;
        return false;
      }
    },
    async inicializa() {
      this.usuarioLogado = this.usuarioAutenticado;
      this.solicitacaoDeAdiantamento.idDoSolicitante = this.usuarioLogado.id;
      await this.$store.dispatch("get", {
        loaderName: "loadingCompanies",
        service: "/empresas",
        itemName: "empresas"
      });
    },
    alteraCampoValor(event, valor) {
      const campoValorTotal = this.solicitacaoDeAdiantamento.total;
      const valorConvertido = conversor.methods.converterValorStringEmNumero(
        campoValorTotal,
        this.solicitacaoDeAdiantamento.tipoDeMoeda
      );

      this.solicitacaoDeAdiantamento.total = conversor.methods.converterParaMoedaReal(
        valorConvertido,
        this.solicitacaoDeAdiantamento.tipoDeMoeda
      );
    },

    validarExcecao() {
      let pedidoEhExcecao = this.retornaExcecao("dialogExcecao");
      if (!pedidoEhExcecao) {
        this.buscarAprovadores();
      }
    },
    calculaRangeDeData(data) {
      const dataFormatada = moment(data);
      const hoje = moment().startOf("day");
      const range = business.weekDays(hoje, dataFormatada);
      const feriado = feriados(data, 5);
      let diaFinal = range + feriado;
      return diaFinal;
    },
    podeVisualizar() {
      if (this.loadingRequest) return true;

      let idDoUsuario = this.usuarioLogado.id;
      let papeis = this.usuarioLogado.papeis;
      let solicitacao = this.solicitacaoDeAdiantamento;

      if (idDoUsuario != solicitacao.idDoSolicitante) {
        if (
          papeis.filter(papel => papel.nome === "APROVADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_GESTOR"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO").length >
          0 &&
          solicitacao.status === "ENVIADO_PARA_FINANCEIRO"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
          solicitacao.status === "ENVIADO_PARA_CONTABILIDADE"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "PROCURADOR").length > 0 &&
          solicitacao.status === "ENVIADO_PARA_PROCURADOR"
        )
          return true;
        else if (
          papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO").length >
          0 &&
          (solicitacao.status === "REPROVADO_PELO_PROCURADOR" ||
            solicitacao.status === "APROVADO_PELO_PROCURADOR")
        )
          return true;
        else return false;
      } else {
        if (
          (papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_ADM_FINANCEIRO") ||
          (papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_FINANCEIRO") ||
          (papeis.filter(papel => papel.nome === "APROVADOR_CONTABILIDADE")
            .length > 0 &&
            solicitacao.status === "ENVIADO_PARA_CONTABILIDADE") ||
          (papeis.filter(papel => papel.nome === "PROCURADOR").length > 0 &&
            solicitacao.status === "ENVIADO_PARA_PROCURADOR") ||
          (papeis.filter(papel => papel.nome === "APROVADOR_FINANCEIRO")
            .length > 0 &&
            (solicitacao.status === "REPROVADO_PELO_PROCURADOR" ||
              solicitacao.status === "APROVADO_PELO_PROCURADOR"))
        )
          return true;

        return false;
      }
    },
    calculaRateios() {
      let valorTotalRateios = 0;
      this.solicitacaoDeAdiantamento.rateios.map(rateio => {
        valorTotalRateios += parseFloat(rateio.valor);
      });
      return valorTotalRateios;
    },
    converteValorStringEmNumero(valor) {
      if (typeof valor != "string") return valor;

      valor = valor
        .replace("R$", "")
        .replace("$", "")
        .replace("￥", "")
        .replace("€", "")
        .replace("£", "")
        .replace("S$", "")
        .replace("Mex$", "");
      if (this.solicitacaoDeAdiantamento.tipoDeMoeda.indexOf("BRL") != -1) {
        valor = valor.replace(/\./g, "");
        valor = valor.replace(",", ".");
      } else if (
        this.solicitacaoDeAdiantamento.tipoDeMoeda.indexOf("EUR") != -1
      ) {
        valor = valor.replace(/\s/g, "");
        valor = valor.replace(",", ".");
      } else {
        valor = valor.replace(/\,/g, "");
      }

      if (isNaN(valor)) {
        valor = 0;
        return valor;
      }

      return valor;
    },
    converteParaMoedaReal(numero) {
      let formatter;
      if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "USD")
        formatter = this.converterOutrasMoedas("en-US", "currency", "USD");
      else if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "AUD")
        formatter = this.converterOutrasMoedas("en-au", "currency", "AUD");
      else if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "CAD")
        formatter = this.converterOutrasMoedas("en-ca", "currency", "CAD");
      else if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "JPY")
        formatter = this.converterOutrasMoedas("ja", "currency", "JPY");
      else if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "EUR")
        formatter = this.converterOutrasMoedas("fr", "currency", "EUR");
      else if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "GBP")
        formatter = this.converterOutrasMoedas("en-gb", "currency", "GBP");
      else if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "SGD")
        formatter = this.converterOutrasMoedas("zh-sg", "currency", "SGD");
      else if (this.solicitacaoDeAdiantamento.tipoDeMoeda == "MXN")
        formatter = this.converterOutrasMoedas("es-mx", "currency", "MXN");
      else formatter = this.converterOutrasMoedas("pt-BR", "currency", "BRL");
      return formatter.format(numero);
    },

    converterOutrasMoedas(linguagem, estilo, pais) {
      return new Intl.NumberFormat(linguagem, {
        style: estilo,
        currency: pais,
        minimumFractionDigits: 2
      });
    },
    formataValorDeAdiantamento(eventoBlur) {
      const converteValorParaAndiantamento = conversor.methods.converterValorStringEmNumero(
        eventoBlur.target.value,
        this.solicitacaoDeAdiantamento.tipoDeMoeda
      );
      this.solicitacaoDeAdiantamento.total = conversor.methods.converterParaMoedaReal(
        converteValorParaAndiantamento,
        this.solicitacaoDeAdiantamento.tipoDeMoeda
      );
    },

    async buscarAprovadores() {
      this.dialogoAprovador = true;
      this.loadingAprovador = true;

      await axios({
        method: "get",
        url: `/usuarios/${this.usuarioLogado.id}/papel/APROVADOR`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          this.aprovadores = resposta.data;
        })
        .catch(erro => {
          console.error("Ocorreo um erro ao buscar aprovadores");
          console.error(erro);
        });

      this.loadingAprovador = false;
    },
    prepararRequest(operacao) {
      this.loadingRequest = true;
      this.solicitacaoDeAdiantamento.idAprovadorLog = this.usuarioLogado.id;

      let copiaSolicitacao = cloneDeep(this.solicitacaoDeAdiantamento);
      copiaSolicitacao.numeroDoPedido = substituirCaracteres(copiaSolicitacao.numeroDoPedido, 0, 30)

      if (operacao === "ENVIAR_PARA_APROVACAO") {
        copiaSolicitacao.idDoAprovador = this.aprovadorSelecionado;
        this.dialogoAprovador = false;
      }

      this.dialogConfirmarAprovacao = false;

      if (operacao === "REPROVAR") {
        this.dialogConfirmarReprovacao = false;
      }

      copiaSolicitacao.total = parseFloat(
        conversor.methods.converterValorStringEmNumero(
          copiaSolicitacao.total,
          copiaSolicitacao.tipoDeMoeda
        )
      );

      copiaSolicitacao.status = this.gerenciaStatusDoAdiantamento(operacao);
      copiaSolicitacao.rateios.map(item => {
        item.valor = parseFloat(item.valor).toFixed(2);
      });
      this.fazerRequest(copiaSolicitacao);
    },
    async fazerRequest(dados) {
      let vm = this;
      let operacaoHTTP = "POST";
      this.loadingRequest = true;
      if (this.solicitacaoDeAdiantamento.id != null) operacaoHTTP = "PUT";

      this.snackbar.ativo = true;
      this.snackbar.color = "primary";
      this.snackbar.text = "Carregando...";

      await axios({
        method: `${operacaoHTTP}`,
        url: `/pedidos/adiantamentos`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        data: JSON.stringify(dados)
      })
        .then(resposta => {
          this.snackbar.ativo = false;
          this.snackbar.color = "success";
          this.snackbar.text = "Salvo com Sucesso!";
          this.snackbar.ativo = true;

          setTimeout(function () {
            vm.$router.push({ name: `solicitacoes` });
          }, 2000);
        })
        .catch(erro => {
          this.snackbar.color = "error";

          this.snackbar.text = `Houve um erro na criação / envio do pedido. Para mais informações entre em contato com o Administrador.`;
          const erroPossuiResposta = erro.response == !undefined
          if (erroPossuiResposta) {
            const codigoErro = erro.response.status;
            const ehErroIntegracao = codigoErro == 502;
            if (ehErroIntegracao) {
              this.solicitacaoDeReembolso.statusIntegracao =
                erro.response.data.statusIntegracao;
              this.solicitacaoDeReembolso.mensagemIntegracao =
                erro.response.data.mensagemIntegracao;
              this.snackbar.text = `Houve um erro na integração do pedido.`;
            }
          }
          
          this.loadingRequest = false;
          this.snackbar.ativo = true;

          const converterValorParaAdiantamento = conversor.methods.converterValorStringEmNumero(
            this.solicitacaoDeAdiantamento.total
          );

          this.solicitacaoDeAdiantamento.total = conversor.methods.converterParaMoedaReal(
            converterValorParaAdiantamento,
            this.solicitacaoDeAdiantamento.tipoDeMoeda
          );
          /*                                                                          
          this.solicitacaoDeAdiantamento.valor = this.converteParaMoedaReal(
            this.converteValorStringEmNumero(
              this.solicitacaoDeAdiantamento.total
            )
          );*/

          console.error(erro);
        });
    },
    async buscaPedidoDeAdiantamento(id) {
      await axios({
        method: "get",
        url: `/pedidos/adiantamentos/${id}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          const usuariosDoPedido = {
            idAprovador: resposta.data.idDoAprovador,
            idRegistrador: resposta.data.idDoSolicitante
          }
          if (validarSeUsuarioLogadoPodeVerPedido(usuariosDoPedido)) {
            this.solicitacaoDeAdiantamento = resposta.data;

            if (this.solicitacaoDeAdiantamento.logs && this.solicitacaoDeAdiantamento.logs.length > 0) {
              this.solicitacaoDeAdiantamento.logs = this.solicitacaoDeAdiantamento.logs.map(log => converterLogParaHorarioDeSaoPaulo(log));
            }

            if (this.solicitacaoDeAdiantamento.total == "") {
            } else {
              const converteValorEmNumero = conversor.methods.converterValorStringEmNumero(
                this.solicitacaoDeAdiantamento.total
              );
              this.solicitacaoDeAdiantamento.total = conversor.methods.converterParaMoedaReal(
                converteValorEmNumero,
                this.solicitacaoDeAdiantamento.tipoDeMoeda
              );
            }

            let s = this.solicitacaoDeAdiantamento;
            let contasBancarias = [...resposta.data.dadosBancariosDoFornecedor];

            contasBancarias.map(c => {
              if (s.pagamento.conta.id == c.id) c.selecionado = true;
              else c.selecionado = false;
            });
            let filtrarContasAtivas = contasBancarias.filter(c => c.estaAtivo);
            let fornecedorComponente = {
              fornecedorDigitado: s.cnpj_cpf,
              fornecedor: {
                id: s.idDoFornecedor,
                nome: s.favorecido,
                dadosBancarios: [...filtrarContasAtivas]
              }
            };
            this.fornecedorRecebido = fornecedorComponente;
            this.configuraPermissaoParaEdicao();
          }
        })
        .catch(erro => {
          console.error("Ocorreo um erro ao buscar pelo pedido de reembolso");
          console.error(erro);
        });
    },
    configuraPermissaoParaEdicao() {
      let usuarioEhUmAprovador =
        this.usuarioLogado.papeis.filter(
          papel => papel.nome.indexOf("APROVADOR") != -1
        ).length > 0;

      let usuarioEhProcurador =
        this.usuarioLogado.papeis.filter(
          papel => papel.nome.indexOf("PROCURADOR") != -1
        ).length > 0 &&
        this.solicitacaoDeAdiantamento.status == "ENVIADO_PARA_PROCURADOR";

      let mesmoAprovador =
        this.solicitacaoDeAdiantamento.idDoAprovador == this.usuarioLogado.id;

      if (
        this.solicitacaoDeAdiantamento.status == "ENVIADO_PARA_GESTOR" &&
        mesmoAprovador
      )
        this.ehAprovador = true;
      else {
        if (
          (usuarioEhUmAprovador || usuarioEhProcurador) &&
          this.solicitacaoDeAdiantamento.status != "ENVIADO_PARA_GESTOR"
        )
          this.ehAprovador = true;
      }

      let solicitacaoNova = this.solicitacaoDeAdiantamento.id === null;
      let usuarioEhSolicitante =
        this.usuarioLogado.id ===
        this.solicitacaoDeAdiantamento.idDoSolicitante;
      let reembolsoFoiReprovado =
        this.solicitacaoDeAdiantamento.status.indexOf("REPROVADO") != -1 &&
        this.solicitacaoDeAdiantamento.status != "REPROVADO_PELO_PROCURADOR";

      if (solicitacaoNova || (usuarioEhSolicitante && reembolsoFoiReprovado))
        this.podeEditar = true;
      else this.podeEditar = false;
    },
    fechar() {
      this.dialogoAprovador = false;
      this.aprovadorSelecionado = "";
    },
    gerenciaStatusDoAdiantamento(operacao) {
      // solicitante
      if (
        operacao === "ENVIAR_PARA_APROVACAO" &&
        this.usuarioLogado.papeis.filter(papel => papel.nome === "SOLICITANTE")
          .length > 0
      ) {
        return "ENVIADO_PARA_GESTOR";
      }

      // aprovadores
      if (operacao === "APROVAR") {
        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "APROVADOR")
            .length > 0 &&
          this.solicitacaoDeAdiantamento.status === "ENVIADO_PARA_GESTOR"
        ) {
          if (
            this.solicitacaoDeAdiantamento.statusDoFornecedor == "EM_ANALISE"
          ) {
            return "ENVIADO_PARA_ADM_FORNECEDOR";
          } else {
            if (this.solicitacaoDeAdiantamento.excecao)
              return "ENVIADO_PARA_ADM_FINANCEIRO";
            else return "ENVIADO_PARA_FINANCEIRO";
          }
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          this.solicitacaoDeAdiantamento.status ===
          "ENVIADO_PARA_ADM_FINANCEIRO"
        ) {
          this.solicitacaoDeAdiantamento.excecao = true;
          return "ENVIADO_PARA_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoDeAdiantamento.status === "ENVIADO_PARA_FINANCEIRO"
        ) {
          return "ENVIADO_PARA_CONTABILIDADE";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacaoDeAdiantamento.status === "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "ENVIADO_PARA_PROCURADOR";
        }

        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "PROCURADOR")
            .length > 0 &&
          this.solicitacaoDeAdiantamento.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "APROVADO_PELO_PROCURADOR";
        }
        //Temporario
        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoDeAdiantamento.status === "REPROVADO_PELO_PROCURADOR"
        ) {
          return "ENVIADO_PARA_PROCURADOR";
        }
      }

      // reprovadores
      if (operacao === "REPROVAR") {
        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "APROVADOR")
            .length > 0 &&
          this.solicitacaoDeAdiantamento.status === "ENVIADO_PARA_GESTOR"
        ) {
          return "REPROVADO_PELO_GESTOR";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          (this.solicitacaoDeAdiantamento.status ===
            "ENVIADO_PARA_FINANCEIRO" ||
            this.solicitacaoDeAdiantamento.status ===
            "REPROVADO_PELO_PROCURADOR")
        ) {
          return "REPROVADO_PELO_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_CONTABILIDADE"
          ).length > 0 &&
          this.solicitacaoDeAdiantamento.status === "ENVIADO_PARA_CONTABILIDADE"
        ) {
          return "REPROVADO_PELA_CONTABILIDADE";
        }

        if (
          this.usuarioLogado.papeis.filter(papel => papel.nome === "PROCURADOR")
            .length > 0 &&
          this.solicitacaoDeAdiantamento.status === "ENVIADO_PARA_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO_EXCECAO"
          ).length > 0 &&
          this.solicitacaoDeAdiantamento.status ===
          "ENVIADO_PARA_ADM_FINANCEIRO"
        ) {
          return "REPROVADO_PELO_ADM_FINANCEIRO";
        }

        if (
          this.usuarioLogado.papeis.filter(
            papel => papel.nome === "APROVADOR_FINANCEIRO"
          ).length > 0 &&
          this.solicitacaoDeAdiantamento.status === "APROVADO_PELO_PROCURADOR"
        ) {
          return "REPROVADO_PELO_PROCURADOR";
        }
      } else return operacao;
    },
    receberFornecedor(event) {
      let contaCorreta = event.dadosBancarios.filter(
        i => i.selecionado == true
      );
      const dadosBancarios = contaCorreta[0];
      this.solicitacaoDeAdiantamento.dadosBancariosDoFornecedor =
        event.dadosBancarios;
      this.solicitacaoDeAdiantamento.pagamento.conta.id = dadosBancarios.id;
      this.solicitacaoDeAdiantamento.idDoFornecedor = event.id;
      this.solicitacaoDeAdiantamento.favorecido = event.nome;
    },
    async buscaDadosBancarios() {
      this.loadingBusca = true;
      if (
        this.solicitacaoDeAdiantamento.cnpj_cpf == null ||
        this.solicitacaoDeAdiantamento.cnpj_cpf == ""
      ) {
        this.loadingBusca = false;
        return;
      }

      let numeroDocumento = this.solicitacaoDeAdiantamento.cnpj_cpf
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      await axios({
        method: "GET",
        url: `/fornecedores/dadosbancario/busca/${numeroDocumento}`,
        responseType: "json",
        headers: {
          Authorization: `Bearer ${this.usuarioLogado.token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(resposta => {
          const dadosBancarios = resposta.data.dadoBancario;
          this.solicitacaoDeAdiantamento.banco = dadosBancarios.banco.nome;
          this.solicitacaoDeAdiantamento.agencia = dadosBancarios.agencia;
          this.solicitacaoDeAdiantamento.contaCorrente = dadosBancarios.conta;
          this.solicitacaoDeAdiantamento.idDoFornecedor = resposta.data.id;
          this.solicitacaoDeAdiantamento.favorecido = resposta.data.nome;
          this.loadingBusca = false;
        })
        .catch(erro => {
          console.error("Ocorreu um erro ao tentar buscar por fornecedor");
          console.error(erro);
          this.solicitacaoDeAdiantamento.banco = "";
          this.solicitacaoDeAdiantamento.agencia = "";
          this.solicitacaoDeAdiantamento.contaCorrente = "";
          this.solicitacaoDeAdiantamento.idDoFornecedor = "";
          this.solicitacaoDeAdiantamento.favorecido = "";
          this.loadingBusca = false;
        });
    }
  },
  async created() {
    await this.inicializa();
    if (this.$route.params.id !== undefined)
      await this.buscaPedidoDeAdiantamento(this.$route.params.id);
  }
};
</script>
<style>
.flex {
  padding: 0px 16px;
}

.noDataSlot {
  font-size: 1em;
  padding: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>